/** @format */

import React from "react";
import Faq from "react-faq-component";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { AiOutlineArrowDown } from "react-icons/ai";

const Faqs = () => {
  const data = {
    //   title: "FAQ (How it works)",
    rows: [
      {
        title: "How do I pay for my transport service?",
        content: `You can choose to pay in full online as we accept all major credit cards, Zelle and Cash App.. You can also pay in cash at the time of delivery. If you choose to pay in cash, there is a small partial payment of $199 or less (depending on the distance of your shipment) when you place your order to secure your car’s spot on a truck.
        `,
      },
      {
        title: "Can you guarantee a pick up or delivery date and time?",
        content: `Guarantee pickup dates…Yes, we can! All you need to do is decide whether you need the car picked up by a specific date or on a specific date, which will determine the extra cost involved to guarantee your time frame. Please call for a customized quote if you need guaranteed pick up date(s). However, because anything can happen on the road, the auto-hauling industry does not guarantee delivery dates.`,
      },

      {
        title: "What is the First Available Shipping Date?",
        content: `This is the date your vehicle is ready to be picked up. However, this is not necessarily the exact pick up date. Depending on truck availability at that particular time, we may be able to assign a truck to load your vehicle on your First Available Shipping Date but it may also be a few days after. If we cannot pick it up that day, it should be within our usual pick up window of 1 to 5 business days starting from that date. For more details see pick up date and time.`,
      },

      {
        title: "What is Door-to-Door auto transport?",
        content: `This means that the truck driver will pick the vehicle up and drop it off as close to your home as he can legally and safely get. Many cities have restrictions on large trucks that prohibit them from driving into some residential areas. Transport trucks are enormous and need a lot of room to maneuver and turn around, so if access to your home is restricted by narrow streets, low-hanging trees, speed bumps or tight turns the driver may ask that you meet the truck at a large parking lot nearby such as a grocery store. You will receive a call directly from the trucker if these alternative arrangements are necessary.
        `,
      },
      {
        title: "Is there any addition costs ?",
        content: `No, the quote is all inclusive. It covers door to door service, full bumper to bumper insurance, all tax and tolls paid, and personal belongings up to 100 lbs free of charge.
        `,
      },
      {
        title: "What payment methods are available on delivery?",
        content: `Drivers are not allowed to accept credit cards or person checks on delivery. If you have an outstanding balance that is due on delivery, please make sure that you have cash, cashier’s check, or money order.
        `,
      },
    ],
  };

  const styles = {
    // bgColor: "#0E0E1DBF",
    titleTextColor: "#EBEEF2",
    rowTitleColor: "#2C3A4B",
    rowContentColor: "##394452",
    arrowColor: "##394452",
    rowContentPaddingTop: "10px",
    rowContentPaddingBottom: "10px",
    rowContentPaddingLeft: "30px",
    rowContentPaddingRight: "30px",
  };

  const config = {
    animate: true,
    // arrowIcon: "V",
    // tabFocus: true
    expandIcon: <IoMdArrowDropdown />,
    collapseIcon: <IoMdArrowDropup />,
    margin: "2px",
  };
  React.useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    scrollToTop();
  }, []);
  return (
    <>
      <div className='container-fluid header-banner position-relative'>
        <div class='background-overlay'></div>
        <div className='container'>
          <div className='inner'>
            <h1>FAQs</h1>
          </div>
        </div>
      </div>
      <div className='container-fluid faqs py-5'>
        <div className='container'>
          <div className='section-heading text-center'>
            <h2 className='accent-large'>
              Frequently Asked <span>Questions</span>
            </h2>
            <p className='sec-title'>
              We also offer discount car shipping services so don’t hesitate to
              ask if you qualify for one.
            </p>
          </div>

          <div className='mt-4 sm:w-9/12 w-full m-auto'>
            <Faq data={data} styles={styles} config={config} />
            {/* <div className="btn_main">
                <button>View All FAQs <AiOutlineArrowDown size={20} /></button>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Faqs;
